import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SessionService } from '../../Services/session.service';
import { EncryptionDecryptionService } from 'src/app/Services/encryption-decryption/encryption-decryption.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { DashboardService } from 'src/app/Services/Dashboard/dashboard.service';
import { DashboardFilters, DashboardDetails, DropDownResponse, JobNumber, Brand } from 'src/app/Models/Dashboard/DashboardFilters';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { PagerService } from 'src/app/Services/pager.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [PagerService, DatePipe]
})
export class HomeComponent implements OnInit {
  @ViewChild('jobnumber') jobnumber;
  @ViewChild('brand') brand;
  @ViewChild('crop') crop;
  @ViewChild('jobtype') jobtype;
  @ViewChild('language') language;
  @ViewChild('rmh') rmh;
  @ViewChild('requirementType') requirementType;
  @ViewChild('requirementYear') requirementYear;
  selectedYear: any[] = [];
  @ViewChild('status') status;
  @ViewChild('ma') ma;
  @ViewChild('month') month;
  bgcolor : string = '#000';
  userName: string;
  roleCode: string;
  userID: string;
  roleID: string;
  isActive : number;
  remarks : string;
  currentYearPlus: any;
    currentYear: any;

  selectedJobNumber: any = '';
  selectedRMHName: any = '';
  selectedJobType: any = '';
  selectedBrand: any = '';
  selectedCrop: any = '';
  selectedLanguage: any = '';
  selectedStatus: any = '';
  selectedMA: any = '';
  selectedRequirementType: any = '';
  selectedRequirementYear: any = '';
  details: DashboardDetails[] = [];
  orderStatus : number = 1;
  dashboardFilters: DashboardFilters = new DashboardFilters();
  displayToDoList: string = 'none';
  public ddlResponse: DropDownResponse = new DropDownResponse();
  displayPONumber: string = 'none';
  loader: string = 'none';
  path: string;
  displayPO: string = 'none';
  jobNumber: any;
  poNumber: any;
  rmhName: string;
  rmhID: string;
  vendorName : string;
  requirementSubmitted: number = 1;
  requirementApproved: number = 1;
  vendorFinalized: number = 0;
  poIssued: number = 0;
  artworkProductionApproved: number = 0;
  materialDispatch: number = 0;
  poDetails: any;
  processTimelineDetail: any;
  // pageSetting: number = 20;
  pageSetting: number = 20;
  pager: any = {};
  model: any[];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  name: string;
  className : string = '';
  date = new Date();
  public jobNumberSettings = {};
  public brandSettings = {};
  public cropSettings = {};
  public jobTypeSettings = {};
  public languageSettings = {};
  public rmhSettings = {};
  public requirementTypeSettings = {};
  public requirementYearSettings = {};
  public statusSettings = {};
  public maSettings = {};
  public monthSettings = {};
  ascNumberSort: boolean = true;
  accessdata:string='';// add by deepanshu 15 june 2023
  currentDate: string;
  sortDirection: string = '';
  monthDropdown = [];
  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }
  ];
 
  constructor(private session: SessionService,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private dialog: MatDialog, private dashboardService: DashboardService,
    private snackBar: MatSnackBarComponent, private _pagerService: PagerService,
    private datePipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.currentDate = this.datePipe.transform(this.date, 'MM/dd/yyyy');
    this.name = localStorage.getItem('mcmt_userName');
    
  }
  ngOnInit(): void {
    clearInterval(this.session.id);
    this.session.startSession();
    this.processTimeline();
    this.selectedPaging = '0';
    this.getDashboardFiltersOnPageLoad();
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    if (this.roleID == '42' || this.roleID == '76') {
      this.selectedRMHName = this.userID;
    }

    this.currentYear = new Date();
        this.currentYearPlus = this.currentYear.getFullYear();

    this.dashboardService.dashboardDetails('', '', '', '', '', '', this.currentYearPlus, '', '','','')
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.details = resdata.data.detail;
          this.model = resdata.data.detail;
          this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
    //this.DashboardDetails();
    this.jobNumberSetting();
    this.brandSetting();
    this.cropSetting();
    this.languageSetting();
    this.statusSetting();
    this.jobTypeSetting();
    this.rmhSetting();
    this.requirementTypeSetting();
    this.requirementYearSetting();
    this.maSetting();
    this.monthSetting();
    this.monthDropdown = [
      { "id": 1, "itemName": "January" },
      { "id": 2, "itemName": "February" },
      { "id": 3, "itemName": "March" },
      { "id": 4, "itemName": "April" },
      { "id": 5, "itemName": "May" },
      { "id": 6, "itemName": "June" },
      { "id": 7, "itemName": "July" },
      { "id": 8, "itemName": "August" },
      { "id": 9, "itemName": "September" },
      { "id": 10, "itemName": "October" },
      { "id": 11, "itemName": "November" },
      { "id": 12, "itemName": "December" }
    ];

  }


  dashboardDetails() {
    this.loader = 'block';
    let selectedJobnumber = '';
    let selectedRMH = '';
    let selectedBrand = '';
    let selectedCrop = '';
    let selectedJobtype = '';
    let selectedLanguage = '';
    let selectedRequirementType = '';
    let selectedRequirementYear = '';
    let selectedStatus = '';
    let selectedMA = '';
    let selectedMonth='';
    selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    if (this.roleID != '42' && this.roleID != '76') {
      selectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      selectedRMH = '';
    }
    if (this.roleID != '42' && this.roleID != '76' &&  this.roleID != '48'&& this.roleID!='57') {
      selectedMA = Array.prototype.map.call(this.ma.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      selectedMA = '';
    }
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    selectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.text; }).join(",");
    selectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
    selectedRequirementType = Array.prototype.map.call(this.requirementType.selectedItems, function (item) { return item.id; }).join(",");
    selectedRequirementYear = Array.prototype.map.call(this.requirementYear.selectedItems, function (item) { return item.id; }).join(",");
    selectedMonth = Array.prototype.map.call(this.month.selectedItems, function (item) { return item.id; }).join(",");
    this.dashboardService.dashboardDetails(selectedJobnumber, selectedRMH, selectedJobtype,
      selectedBrand, selectedCrop, selectedRequirementType,selectedRequirementYear, selectedLanguage, selectedStatus, selectedMA,selectedMonth)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.details = resdata.data.detail;
          this.model = resdata.data.detail;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  getDashboardFiltersOnPageLoad() {
    this.loader = 'block';
    this.dashboardService.dashboardFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          debugger;
          //this.dashboardFilters = resData.data as DashboardFilters;
          this.ddlResponse = resData.data;
          this.accessdata=resData.data.access[0].access; //add by deepanshu 15 june
          sessionStorage.setItem('Acccess',this.accessdata);
         // alert(this.accessdata);//add by deepanshu 15 june
          //this.ddlResponse.brands=resData.data;
          this.onCurrentYearSelected(this.ddlResponse.requirementYear)

          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }


  public onCurrentYearSelected(item: any) {
    class YearItemList{
      id: any;
      text: any;
  }
    let requiredItem: YearItemList[] = [];
    var obj = {
      id : (new Date()).getFullYear().toString(),
      text: (new Date()).getFullYear().toString()
    }

    requiredItem.push(obj)
    this.requirementYear.selectedItems=requiredItem
    for (var i = 0; i < this.requirementYear.selectedItems.length; i++) {
      this.selectedYear.push(this.requirementYear.selectedItems[i].text)
    }
    //this.commaSeperatedStatus = this.selectedStatusType.join(", ");
    this.requirementYearSetting();
  }



  getDashboardFilters() {
    this.loader = 'block';
    this.dashboardService.dashboardFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.ddlResponse = resData.data;
         
         
          this.ascNumberSort = true;
          this.sortDirection = '';

          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.ascNumberSort = true;
          this.sortDirection = '';
          this.loader = 'none';
        }
      }
      );
  }
  excelDownload() {
    this.loader = 'block';
    let selectedJobnumber = '';
    let selectedRMH = '';
    let selectedBrand = '';
    let selectedCrop = '';
    let selectedJobtype = '';
    let selectedLanguage = '';
    let selectedRequirementType = '';
    let selectedRequirementYear = '';
    let selectedStatus = '';
    let selectedMA = '';
    let selectedMonth='';
    selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    if (this.roleID != '42' && this.roleID != '76') {
      selectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      selectedRMH = '';
    }
    if (this.roleID != '42' && this.roleID != '76' &&  this.roleID != '48'&& this.roleID!='57') {
      selectedMA = Array.prototype.map.call(this.ma.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      selectedMA = '';
    }
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    selectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.text; }).join(",");
    selectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
    selectedRequirementType = Array.prototype.map.call(this.requirementType.selectedItems, function (item) { return item.id; }).join(",");
    selectedRequirementYear = Array.prototype.map.call(this.requirementYear.selectedItems, function (item) { return item.id; }).join(",");
    selectedMonth = Array.prototype.map.call(this.month.selectedItems, function (item) { return item.id; }).join(",");


    this.dashboardService.downloadExcel(selectedJobnumber, selectedRMH, selectedJobtype,
      selectedBrand, selectedCrop, selectedRequirementType,selectedRequirementYear, selectedLanguage,
      selectedStatus, selectedMA,selectedMonth)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datePipe.transform(date, 'dd-MMM-yy')
          let name = localStorage.getItem('mcmt_userName').split(' ');
          let firstname = name[0];
          let lastName = name[1];
          let excelName = firstname + '_' + lastName + '_Dashboard_' + latest_date + '.xlsx';
          saveAs(success, excelName);
          this.loader = 'none';
        },
        err => {
          this.toastr.error("Some problem occurred while downloading file.");
          this.loader = 'none';
        }
      );
  }

  downloadLink(fileName: string): void {
    let url: string = '/Templates/' + fileName;
    this.dashboardService.downloadFile(fileName, url);
  }
  changeJobNumber(event: any) {
    this.selectedJobNumber = event.target.value;
  }
  changeRMHName(event: any) {
    this.selectedRMHName = event.target.value;
  }
  changeJobType(event: any) {
    this.selectedJobType = event.target.value;
  }
  changeBrand(event: any) {
    this.selectedBrand = event.target.value;
  }
  changeCrop(event: any) {
    this.selectedCrop = event.target.value;
  }
  changeLanguage(event: any) {
    this.selectedLanguage = event.target.value;
  }
  changeRequirementType(event: any) {
    this.selectedRequirementType = event.target.value;
  }
  changeRequirementYear(event: any) {
    this.selectedRequirementYear = event.target.value;
  }
  changeOrderStatus(event: any) {
    this.selectedStatus = event.target.value;
  }
  filter() {
    this.dashboardDetails();
  }
  logout() {
    this.session.logout();
  }

  openToDoList() {
    this.displayToDoList = 'block';
  }

  closeToDoList() {
    this.displayToDoList = 'none';
  }
  openPO(poNumber: string, rmhName: string, jobNumber: any, status : string) {
    this.dashboardService.getPODetails(jobNumber)
      .subscribe((resData: any) => {
        debugger;
        if (resData.status == true) {
          this.poDetails = resData.data;
          console.log(this.poDetails);
          this.jobNumber = jobNumber;
          this.rmhName = rmhName;
          this.rmhID = resData.data[0].rmh;
          this.poNumber = poNumber;
          this.vendorName = resData.data[0].vendorName;
          this.isActive = resData.data[0].isActive;
          this.remarks = resData.data[0].cancellationStatus;
          const body = document. getElementsByTagName('body')[0];
          body. classList. add('overlay-back');

          if(status == 'Vendor Finalization Pending'){
            this.orderStatus = 2;
          }
          else if(status == 'PO Issuance Pending'){
            this.orderStatus = 3;
          }
          else if(status == 'Artwork Required'){
            this.orderStatus = 4;
          }
          else if(status == 'Artwork Approval Awaited'){
            this.orderStatus = 4;
          }
          else if(status == 'Printer to Share JPEG'){
            this.orderStatus = 4;
          }
          else if(status == 'Production In Process'){
            this.orderStatus = 5;
          }
          else if(status == 'Production Done'){
            this.orderStatus = 6;
          }
          else if(status == 'Material To Be Received At WH'){
            this.orderStatus = 7;
          }
          else if(status == 'Material received by Warehouse'){
            this.orderStatus = 8;
          }
          else if(status == 'Dispatched by Printer'){//'Material Allocation To Be Received'){
            this.orderStatus = 7;
          }
          else if(status == 'Dispatch To Field In Process'){
            this.orderStatus = 8;
          }
          else if(status == 'Field Team Confirmation Pending'){
            this.orderStatus = 9;
          }
          else if(status == 'Received by Field team'){
            this.orderStatus = 9;
          }
          else if(status == 'JobNumber Cancelled'){
            var currentStatus = resData.data[0].statusWhenCancel;
            if(currentStatus == 'Vendor Finalization Pending'){
              this.orderStatus = 2;
            }
            else if(currentStatus == 'PO Issuance Pending'){
              this.orderStatus = 3;
            }
            else if(currentStatus == 'Artwork Required'){
              this.orderStatus = 4;
            }
            else if(currentStatus == 'Artwork Approval Awaited'){
              this.orderStatus = 4;
            }
            else if(currentStatus == 'Printer to Share JPEG'){
              this.orderStatus = 4;
            }
            else if(currentStatus == 'Production In Process'){
              this.orderStatus = 5;
            }
            else 
            {
              this.orderStatus = 1;
            }
          }
          else{
            this.orderStatus = 1;
          }

          this.displayPO = 'block';
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
        }
      }
      );
  }

  closePO() {
    this.displayPO = 'none';          
    const body = document. getElementsByTagName('body')[0];
    body. classList. remove('overlay-back');
  }

  processTimeline() {
    this.dashboardService.getProcessTimeline()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.processTimelineDetail = resData.data;
        }
        else {
          this.toastr.error(resData.msg);
        }
      }
      );
  }

  getJobnumberWiseData(filter: any) {
    this.loader = 'block';
    let selectedJobnumber = '';
    selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    this.dashboardService.getrmhonjobnumberselection(selectedJobnumber, '', '', '')
      .subscribe((response) => {
        if (response.status) {
          this.jobnumber.selectedItems = response.data.selectedjobnumber.map(item => { return { id: item.jobNumber, text: item.jobNumber } });
          this.brand.selectedItems = response.data.brands.map(item => { return { id: item.brandID, text: item.brandName } });
          this.crop.selectedItems = response.data.crops.map(item => { return { id: item.cropID, text: item.cropName } });
          this.jobtype.selectedItems = response.data.jobTypes.map(item => { return { id: item.jobTypeID, text: item.jobTypeName } });
          this.language.selectedItems = response.data.languages.map(item => { return { id: item.languageID, text: item.languageName } });
          if (this.roleID != '42' && this.roleID != '76') {
            this.rmh.selectedItems = response.data.rmhs.map(item => { return { id: item.rMHCode, text: item.rMHName } });

          }
          if (this.roleID != '42' && this.roleID != '76' &&  this.roleID != '48' && this.roleID!='57') {
            this.ma.selectedItems = response.data.ma.map(item => { return { id: item.ma, text: item.ma } });
          }
          this.requirementType.selectedItems = response.data.requirementTypes.map(item => { return { id: item.requirementTypeID, text: item.requirementTypeName } });
          this.requirementYear.selectedItems = response.data.requirementYear.map(item => { return { id: item.year, text: item.year } });
         
          this.status.selectedItems = response.data.status.map(item => { return { id: item.requirementStatusID, text: item.requirementStatusName } });
          this.loader = 'none';
        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  getRMHWiseData(filter: any) {
    this.loader = 'block';
    let selectedRMH = '';
    selectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    this.dashboardService.getrmhonjobnumberselection('', selectedRMH, '', '')
      .subscribe((response) => {
        if (response.status) {

          this.language.selectedItems = response.data.languages.map(item => { return { id: item.languageID, text: item.languageName } });
          this.loader = 'none';
        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  getMAWiseData(filter: any) {
    this.loader = 'block';
    let selectedMA = '';
    selectedMA = Array.prototype.map.call(this.ma.selectedItems, function (item) { return item.id; }).join(",");
    this.dashboardService.getrmhonjobnumberselection('', '', '', selectedMA)
      .subscribe((response) => {
        if (response.status) {
          this.rmh.selectedItems = response.data.rmhs.map(item => { return { id: item.rMHCode, text: item.rMHName } });
          this.loader = 'none';
        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  getbrandWiseData(filter: any) {
    this.loader = 'block';
    let selectedbrand = '';
    selectedbrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    this.dashboardService.getrmhonjobnumberselection('', '', selectedbrand, '')
      .subscribe((response) => {
        if (response.status) {
          if (response.data.brands.length > 0) {
            this.brand.selectedItems = response.data.brands.map(item => { return { id: item.brandID, text: item.brandName } });
            this.crop.selectedItems = response.data.crops.map(item => { return { id: item.cropID, text: item.cropName } });
            this.jobtype.selectedItems = response.data.jobTypes.map(item => { return { id: item.jobTypeID, text: item.jobTypeName } });
            this.language.selectedItems = response.data.languages.map(item => { return { id: item.languageID, text: item.languageName } });
          }
          else
            this.jobnumber.selectedItems = [];
          this.loader = 'none';
        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  jobNumberSetting() {
    this.jobNumberSettings = {
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Job Number Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  onJobNumberSelect(item: any) {
    this.getJobnumberWiseData(this.jobnumber.selectedItems);
  }
  onJobNumberSelectAll(item: any) {
    this.getJobnumberWiseData(this.jobnumber.selectedItems);
  }
  onJobNumberDeSelect(item: any) {
    this.getJobnumberWiseData(this.jobnumber.selectedItems);
    if (this.jobnumber.selectedItems.length == 0) {
      this.jobnumber.selectedItems = [];
      this.brand.selectedItems = [];
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
      this.language.selectedItems = [];
      if (this.roleID != '42' && this.roleID != '76') {
        this.rmh.selectedItems = [];
      }
      if (this.roleID != '42' && this.roleID != '76' && this.roleID != '48'&& this.roleID!='57') {
        this.ma.selectedItems = [];
      }
      this.requirementType.selectedItems = [];
      this.requirementYear.selectedItems = [];
      this.status.selectedItems = [];
    }
  }
  onJobNumberDeSelectAll(item: any) {

    if (this.roleID != '42' && this.roleID != '76') {
      this.getDashboardFiltersOnPageLoad();
      this.dashboardService.dashboardDetails('', '', '', '', '', '', '', '', '','','')
        .subscribe((resdata: any) => {
          if (resdata.status == true) {
            this.details = resdata.data.detail;
            this.model = resdata.data.detail;
            this.setPage(1, this.pageSetting)
            this.loader = 'none';
          }
          else {
            this.toastr.error(resdata.msg);
            this.loader = 'none';
          }
        })
      this.jobnumber.selectedItems = [];
      this.brand.selectedItems = [];
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
      this.language.selectedItems = [];
      if (this.roleID != '42' && this.roleID != '76') {
        this.rmh.selectedItems = [];
      }
      if (this.roleID != '42' && this.roleID != '76' && this.roleID != '48'&& this.roleID!='57') {
        this.ma.selectedItems = [];
      }
      this.requirementType.selectedItems = [];
      this.requirementYear.selectedItems = [];
      this.status.selectedItems = [];
    }
  }
  onMASelect(item: any) {

    this.getMAWiseData(this.ma.selectedItems);

  }
  onMASelectAll(item: any) {
    this.getMAWiseData(this.ma.selectedItems);

  }
  onMADeSelect(item: any) {
    // this.jobnumber.selectedItems=[];
    this.rmh.selectedItems = [];
  }
  onMADeSelectAll(item: any) {
    //this.jobnumber.selectedItems=[];
    this.rmh.selectedItems = [];
  }
  onRMHSelect(item: any) {

    this.getRMHWiseData(this.rmh.selectedItems);

  }
  onRMHSelectAll(item: any) {
    this.getRMHWiseData(this.rmh.selectedItems);

  }

  onRMHDeSelect(item: any) {
    // this.jobnumber.selectedItems=[];
    this.language.selectedItems = [];
  }
  onRMHDeSelectAll(item: any) {
    //this.jobnumber.selectedItems=[];
    this.language.selectedItems = [];
  }
  onbrandSelect(item: any) {
    this.getbrandWiseData(this.brand.selectedItems);
  }
  onbrandSelectAll(item: any) {
    this.getbrandWiseData(this.brand.selectedItems);
  }
  onbrandDeSelect(item: any) {
    if (this.brand.selectedItems.length < 1) {
      this.brand.selectedItems = [];
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
      this.language.selectedItems = [];
    }
    else
      this.getbrandWiseData(this.brand.selectedItems);
  }
  onbrandDeSelectAll(item: any) {
    this.brand.selectedItems = [];
    this.crop.selectedItems = [];
    this.jobtype.selectedItems = [];
    this.language.selectedItems = [];
  }
  brandSetting() {
    this.brandSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Brand Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  cropSetting() {
    this.cropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Crop Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  jobTypeSetting() {
    this.jobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No JobType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  languageSetting() {
    this.languageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Language Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  rmhSetting() {
    this.rmhSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  requirementTypeSetting() {
    this.requirementTypeSettings = {
      singleSelection: false,
      idField: 'requirementTypeID',
      textField: 'requirementTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RequirementType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  requirementYearSetting() {
    this.requirementYearSettings = {
      singleSelection: false,
      idField: 'year',
      textField: 'year',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RequirementYear Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  maSetting() {
    this.maSettings = {
      singleSelection: false,
      idField: 'ma',
      textField: 'ma',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RequirementType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  statusSetting() {
    this.statusSettings = {
      singleSelection: false,
      idField: 'requirementStatusID',
      textField: 'requirementStatusName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  monthSetting() {
    this.monthSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Month Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  // Start :For Pagination
  setPage(page: number, pageSize: number) {
     // get pager object from service
     if (this.modalSetting == 0) {
       this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
       this.details = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
     }
     else {
       if (this.modalSetting == 1) {
         this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
         this.details = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
       }
       else {
         this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
         this.details = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
       }
     }
     // get current page of items
   }

  sort() {
    let sortedArray: DashboardDetails[] = [];
    let splitString: any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownList.forEach(x => {
        this.model.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.details = sortedArray;
    }
    else {
      this.dropdownList.forEach(x => {
        this.model.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.details = sortedArray.reverse();
    }
  }

  color(index: any){
    if(this.details[index].approvedQuantity != ''){
      if(this.details[index].approvedQuantity == this.details[index].requestedQuantity && this.details[index].approvedQuantity != 0){
        this.bgcolor = '#fff';
        return '#0a9020';
      }
      else{
        this.bgcolor = '#fff';
        return '#f50008';
      }
    }
    else{
      this.bgcolor = '#000';
    }
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
